import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import {
  withStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import { Link as MuiLink } from "@material-ui/core";

import Header from "../../../Component/NavBar/User/Header/Header";
import Footer from "../../../Component/NavBar/User/Footer/Footer";
import { useStyles } from "./PublishBook.css";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#0a1f3a",
    },
  },
});

class PrePublishRules extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accept: false,
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <Header />
        <div className={classes.root}>
          <div style={{ fontSize: 30, fontWeight: "bold" }}>
            Rules for publishing
          </div>
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div>
              <ol style={{ fontSize: 18, textAlign: "justify" }}>
                <li>Book title must be present.</li>
                <li>Author name cannot be changed when filling the form</li>
                <li>
                  The price, total pages must be mentioned properly for the
                  book.
                </li>
                <li>
                  The front book cover must be uploaded if you don't have book
                  cover you can contact us as well.
                </li>
                <li>
                  You must use pdf format of your book in order to publish your
                  book.
                </li>
              </ol>

              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <ThemeProvider theme={theme}>
                  <Checkbox
                    color="primary"
                    checked={this.state.accept}
                    onChange={(e) =>
                      this.setState({ accept: e.target.checked })
                    }
                    name="termsAccept"
                  />
                </ThemeProvider>
                <div>
                  I accept all the &nbsp;
                  {
                    <MuiLink href={"/termsandcondition"}>
                      terms and conditions
                    </MuiLink>
                  }
                  .
                </div>
              </div>
              <Button
                variant="outlined"
                disabled={this.state.accept === false ? true : false}
                className={classes.buttonStyle}
                onClick={() => this.props.history.push("/book/publish")}
              >
                Start Publishing
              </Button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(useStyles)(withRouter(PrePublishRules));
